import { SecureAction } from '../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class SensorSecureAction extends SecureAction {
  public static readonly CREATE_SENSOR_TYPE: SecureAction = new SensorSecureAction('sensor:types|create');
  public static readonly UPDATE_SENSOR_TYPE: SecureAction = new SensorSecureAction('sensor:types|update');
  public static readonly DELETE_SENSOR_TYPE: SecureAction = new SensorSecureAction('sensor:types|delete');
  public static readonly VIEW_SENSOR_TYPE: SecureAction = new SensorSecureAction('sensor:types|view');
  public static readonly EDIT_SENSOR: SecureAction = new SensorSecureAction('sensor:edit|sensors');
  public static readonly CREATE_SENSOR: SecureAction = new SensorSecureAction(`sensor:${SensorSecureAction.VERBS.CREATE}|sensors`);

  public static readonly CREATE_SENSORS_MANUAL: SecureAction = new SensorSecureAction(`sensor:manual|${SensorSecureAction.VERBS.CREATE}`);
  public static readonly VIEW_SENSORS_MANUAL: SecureAction = new SensorSecureAction(`sensor:manual|${SensorSecureAction.VERBS.VIEW}`);

  private constructor(name: string) {
    super(name);
  }
}
